import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-price-list-servis',
  templateUrl: './price-list-servis.component.html',
  styleUrls: ['./price-list-servis.component.css']
})
export class PriceListServisComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
